const FormActionTypes = {
  CHANGE_FORM_INPUT: "CHANGE_FORM_INPUT",
  POST_FORM_START: "POST_FORM_START",
  POST_FORM_SUCCESS: "POST_FORM_SUCCESS",
  POST_FORM_FAILURE: "POST_FORM_FAILURE"
};

export default FormActionTypes;
